export default {
    saveAsNewUrl: null,
    currentYear: null,
    startDate: null,
    endDate: null,
    newYear: null
}
